/*eslint-disable*/
import {
  ADD_USER,
  CREATE_TEAM,
  DELETE_USER,
  EDIT_TEAM,
  GET_ALL_TEAMS,
  GET_TEAM,
  GET_TEAMS_FILTERED,
  PAGINATE_TEAMS,
  UPDATE_TEAM,
} from "../actionTypes";
import axios from "axios";
import { baseUriUsers, envHost, loginUri } from "../../uri";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import i18n from "../../i18n";

export const getAllTeams = () => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUriUsers}/service-user/v1/teams?page=0&size=7`
    );
    dispatch({
      type: GET_ALL_TEAMS,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    if (e.response.status === 403) {
      toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      window.location.href = `${loginUri}${envHost}`;
    } else {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

export const addUser = (user: any, team: any) => async (dispatch: any) => {
  try {
    const editedTeam = team;
    editedTeam.users.push(user);
    const res = await axios.post(
      `${baseUriUsers}/service-user/v1/users/${user.id}/teams/${team.id}`
    );
    dispatch({
      type: ADD_USER,
      payload: res.data,
    });
    toast.success(i18n.t("SUCCESS"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const deleteUser = (userId: string, team: any) => async (
  dispatch: any
) => {
  try {
    const editedTeam = team;
    for (let i = 0; i <= team.users.lenght; i++) {
      team.users[i].id === userId && team.users.splice(i, 1);
    }
    editedTeam.users.map(
      (u: any, i: any) => u.id === userId && team.users.splice(i, 1)
    );
    const res = await axios.delete(
      `${baseUriUsers}/service-user/v1/users/${userId}/teams/${team.id}`
    );
    dispatch({
      type: DELETE_USER,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const getTeam = (id: string) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(`${baseUriUsers}/service-user/v1/teams/${id}`);
    dispatch({
      type: GET_TEAM,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const editTeam = (team: any) => async (dispatch: any) => {
  try {
    const editedTeam = {
      id: team.id,
      name: team.name,
      internal: team.internal,
    };
    const res = await axios.put(
      `${baseUriUsers}/service-user/v1/teams/${team.id}`,
      editedTeam
    );
    dispatch({
      type: EDIT_TEAM,
      payload: res.data,
    });
    toast.success(i18n.t("SUCCESS"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const updateTeam = (field: string, value: string, team: any) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    team[field] = value;
    dispatch({
      type: UPDATE_TEAM,
      payload: team,
    });
    const res = await axios.put(
        `${baseUriUsers}/service-user/v1/teams/${team.id}`,
        team
    );
    toast.success(i18n.t("SUCCESS"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const getTeamsFiltered = (filter: any) => async (
  dispatch: (arg0: { type: string; payload: void }) => void
) => {
  try {
    const queryString = window.location.search;
    const res = await axios.get(
      `${baseUriUsers}/service-user/v1/teams${
        filter ? `?${filter}&size=7` : "?size=7"
      }`
    );
    dispatch({
      type: GET_TEAMS_FILTERED,
      payload: res.data,
    });
  } catch (e) {
    if (e.code !== "ECONNABORTED") {
      toast.error(i18n.t("ERROR_MESSAGES.URL"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

export const paginateTeams = (pageNumber: any, filter: string) => async (
  dispatch: (arg0: { type: any; payload: any }) => void
) => {
  try {
    let res;
    if (filter !== "") {
      res = await axios.get(
        `${baseUriUsers}/service-user/v1/teams?page=${pageNumber - 1}${
          filter && `&${filter}`
        }&size=7`
      );
    } else {
      res = await axios.get(
        `${baseUriUsers}/service-user/v1/teams?page=${pageNumber - 1}&size=7`
      );
    }
    dispatch({
      type: PAGINATE_TEAMS,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const createTeam = (team: any) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios
      .post(`${baseUriUsers}/service-user/v1/teams`, team)
      .then(() => {});

    dispatch({
      type: CREATE_TEAM,
      payload: res,
    });
    toast.success(i18n.t("SUCCESS"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }

    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
